
import * as Moment from "moment";
import Enumerable from "linq";
import { Component, Mixins, Watch } from "vue-property-decorator";
import { ModelEditableMixin } from "../../mixins";
import { EraAsJapaneseCalendar } from "../../../../domain/system";

@Component({
  components: {}
})
export default class DateEditableMixin extends Mixins(ModelEditableMixin) {
  data(): any {
    return {
      editingYearAsJapaneseCalendar: null,
      editingEraName: "",
      isJapaneseCalendarEditable: false,
    };
  }
  editingYearAsJapaneseCalendar: number;
  editingEraName: string;
  isJapaneseCalendarEditable: boolean;

  get year(): number {
    return this.editingSource.getFullYear();
  }

  set year(value: number) {
    const year = this.getAdjustedYear(value, 0, 4);
    this.editingSource = Moment(this.editingSource).add(year - this.year, "years").toDate();
  }

  get month(): number {
    return this.editingSource.getMonth() + 1;
  }

  set month(value: number) {
    this.editingSource = Moment(this.editingSource).add(value - this.month, "months").toDate();
  }

  get day(): number {
    return this.editingSource.getDate();
  }

  set day(value: number) {
    this.editingSource = Moment(this.editingSource).add(value - this.day, "days").toDate();
  }

  get hours(): number {
    return this.editingSource.getHours();
  }

  set hours(value: number) {
    this.editingSource = Moment(this.editingSource).add(value - this.hours, "hours").toDate();
  }

  get minutes(): number {
    return this.editingSource.getMinutes();
  }

  set minutes(value: number) {
    this.editingSource = Moment(this.editingSource).add(value - this.minutes, "minutes").toDate();
  }

  get seconds(): number {
    return this.editingSource.getSeconds();
  }

  set seconds(value: number) {
    this.editingSource = Moment(this.editingSource).add(value - this.seconds, "seconds").toDate();
  }

  get yearAsJapaneseCalendar(): number {
    if (this.editingYearAsJapaneseCalendar === null) {
      this.editingYearAsJapaneseCalendar = this.eraAsJapaneseCalendar.year;
    }
    return this.isJapaneseCalendarEditable ? this.editingYearAsJapaneseCalendar : this.eraAsJapaneseCalendar.year;
  }

  set yearAsJapaneseCalendar(value: number) {
    const year = this.getAdjustedYear(value, 0, 2);
    this.applyYearToEditingSource(this.eraNameAsJapaneseCalendar, year);
    this.editingYearAsJapaneseCalendar = year;
  }

  get eraAsJapaneseCalendar(): EraAsJapaneseCalendar {
    return EraAsJapaneseCalendar.from(this.editingSource);
  }

  get eraNameAsJapaneseCalendar(): string {
    if (!this.editingEraName) {
      this.editingEraName = this.eraAsJapaneseCalendar.name;
    }
    return this.isJapaneseCalendarEditable ? this.editingEraName : this.eraAsJapaneseCalendar.name;
  }

  set eraNameAsJapaneseCalendar(value: string) {
    this.applyYearToEditingSource(value, this.yearAsJapaneseCalendar);
    this.editingEraName = value;
  }

  applyYearToEditingSource(eraName: string, yearAsJapaneseCalendar: number): void {
    const originYear = Enumerable.from(this.$configuration.system.date.japaneseEras)
      .firstOrDefault(o => o.name === eraName).origin.year;
    const newValue = Number(originYear - 1) + Number(yearAsJapaneseCalendar); // 選択中の元号の開始年に選択中の年を足す
    this.editingSource = Moment(this.editingSource).add(newValue - this.year, "years").toDate();
  }

  getAdjustedYear(value: number, start: number, end: number): number {
    // コントロールに数値以外も入力できるため、parseIntしてからNaNチェックをする
    const year = parseInt(value.toString(), 10);
    if (Number.isNaN(year)) { return 0; }
    return Number(year.toString().slice(start, end));
  }

  @Watch("isJapaneseCalendarEditable")
  onIsJapaneseCalendarEditableUpdated(newValue: boolean, oldValue: boolean) {
    if (!newValue) { return; }
    this.editingEraName = this.eraAsJapaneseCalendar.name;
    this.editingYearAsJapaneseCalendar = this.eraAsJapaneseCalendar.year;
  }
}
